(() => {
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $c4926bcb88dfb64a$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return n(r, t, e, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return n(r, t, e, u, a, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return n(r, t, e, u, a, i, o);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, a) {
        return 5 === n.a ? n.f(r, t, e, u, a) : n(r)(t)(e)(u)(a);
    }
    function A6(n, r, t, e, u, a, i) {
        return 6 === n.a ? n.f(r, t, e, u, a, i) : n(r)(t)(e)(u)(a)(i);
    }
    function A7(n, r, t, e, u, a, i, o) {
        return 7 === n.a ? n.f(r, t, e, u, a, i, o) : n(r)(t)(e)(u)(a)(i)(o);
    }
    var t = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), e = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, f(t, r);
    });
    function u(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function a(n, r) {
        for(var t, e = [], u = i(n, r, 0, e); u && (t = e.pop()); u = i(t.a, t.b, 0, e));
        return u;
    }
    function i(n, r, t, e) {
        if (t > 100) return e.push(f(n, r)), !0;
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && u(5), !1;
        for(var a in 0 > n.$ && (n = sr(n), r = sr(r)), n)if (!i(n[a], r[a], t + 1, e)) return !1;
        return !0;
    }
    function o(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = o(n.a, r.a)) || (t = o(n.b, r.b)) ? t : o(n.c, r.c);
        for(; n.b && r.b && !(t = o(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var c = F2(function(n, r) {
        var t = o(n, r);
        return 0 > t ? br : t ? vr : dr;
    });
    function f(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function s(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function d(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    function v(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = l(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = l(n.a, r);
        return t;
    }
    var b = {
        $: 0
    };
    function l(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var h = F2(l);
    function $(n) {
        for(var r = b, t = n.length; t--;)r = l(n[t], r);
        return r;
    }
    var g = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return $(e);
    }), p = Math.ceil, m = Math.floor, y = Math.round, w = Math.log, x = F2(function(n, r) {
        return r.split(n);
    }), A = F2(function(n, r) {
        return r.join(n);
    }), j = F3(function(n, r, t) {
        return t.slice(n, r);
    }), k = F2(function(n, r) {
        for(var t = r.length; t--;){
            var e = r[t], u = r.charCodeAt(t);
            if (56320 > u || u > 57343 || (e = r[--t] + e), !n(e)) return !1;
        }
        return !0;
    }), _ = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), L = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), E = F2(function(n, r) {
        var t = n.length;
        if (1 > t) return b;
        for(var e = 0, u = []; (e = r.indexOf(n, e)) > -1;)u.push(e), e += t;
        return $(u);
    });
    function N(n) {
        return n + "";
    }
    function T(n) {
        return {
            $: 2,
            b: n
        };
    }
    var O = T(function(n) {
        return "number" != typeof n ? Y("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? pr(n) : !isFinite(n) || n % 1 ? Y("an INT", n) : pr(n);
    }), R = (T(function(n) {
        return "boolean" == typeof n ? pr(n) : Y("a BOOL", n);
    }), T(function(n) {
        return "number" == typeof n ? pr(n) : Y("a FLOAT", n);
    })), C = T(function(n) {
        return pr(n);
    }), P = T(function(n) {
        return "string" == typeof n ? pr(n) : n instanceof String ? pr(n + "") : Y("a STRING", n);
    }), M = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function S(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var J = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), U = F2(function(n, r) {
        return S(n, [
            r
        ]);
    }), F = F3(function(n, r, t) {
        return S(n, [
            r,
            t
        ]);
    }), B = F4(function(n, r, t, e) {
        return S(n, [
            r,
            t,
            e
        ]);
    }), D = F5(function(n, r, t, e, u) {
        return S(n, [
            r,
            t,
            e,
            u
        ]);
    }), H = F2(function(n, r) {
        return I(n, r);
    });
    function I(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? pr(n.c) : Y("null", r);
            case 3:
                return G(r) ? q(n.b, r, $) : Y("a LIST", r);
            case 4:
                return G(r) ? q(n.b, r, z) : Y("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return Y("an OBJECT with a field named `" + t + "`", r);
                var e = I(n.b, r[t]);
                return ot(e) ? e : lr(A2($r, t, e.a));
            case 7:
                var u = n.e;
                return G(r) ? r.length > u ? (e = I(n.b, r[u]), ot(e) ? e : lr(A2(gr, u, e.a))) : Y("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : Y("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || G(r)) return Y("an OBJECT", r);
                var a = b;
                for(var i in r)if (r.hasOwnProperty(i)) {
                    if (e = I(n.b, r[i]), !ot(e)) return lr(A2($r, i, e.a));
                    a = l(f(i, e.a), a);
                }
                return pr(Ur(a));
            case 9:
                for(var o = n.f, c = n.g, s = 0; c.length > s; s++){
                    if (e = I(c[s], r), !ot(e)) return e;
                    o = o(e.a);
                }
                return pr(o);
            case 10:
                return e = I(n.b, r), ot(e) ? I(n.h(e.a), r) : e;
            case 11:
                for(var d = b, v = n.g; v.b; v = v.b){
                    if (e = I(v.a, r), ot(e)) return e;
                    d = l(e.a, d);
                }
                return lr(mr(Ur(d)));
            case 1:
                return lr(A2(hr, n.a, r));
            case 0:
                return pr(n.a);
        }
    }
    function q(n, r, t) {
        for(var e = r.length, u = Array(e), a = 0; e > a; a++){
            var i = I(n, r[a]);
            if (!ot(i)) return lr(A2(gr, a, i.a));
            u[a] = i.a;
        }
        return pr(t(u));
    }
    function G(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function z(n) {
        return A2(it, n.length, function(r) {
            return n[r];
        });
    }
    function Y(n, r) {
        return lr(A2(hr, "Expecting " + n, r));
    }
    function Z(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return Z(n.b, r.b);
            case 6:
                return n.d === r.d && Z(n.b, r.b);
            case 7:
                return n.e === r.e && Z(n.b, r.b);
            case 9:
                return n.f === r.f && W(n.g, r.g);
            case 10:
                return n.h === r.h && Z(n.b, r.b);
            case 11:
                return W(n.g, r.g);
        }
    }
    function W(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!Z(n[e], r[e])) return !1;
        return !0;
    }
    var K = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function Q(n) {
        return n;
    }
    function V(n) {
        return {
            $: 0,
            a: n
        };
    }
    function X(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var nn = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), rn = 0;
    function tn(n) {
        var r = {
            $: 0,
            e: rn++,
            f: n,
            g: null,
            h: []
        };
        return fn(r), r;
    }
    function en(n) {
        return X(function(r) {
            r(V(tn(n)));
        });
    }
    function un(n, r) {
        n.h.push(r), fn(n);
    }
    var an = F2(function(n, r) {
        return X(function(t) {
            un(n, r), t(V(0));
        });
    }), on = !1, cn = [];
    function fn(n) {
        if (cn.push(n), !on) {
            for(on = !0; n = cn.shift();)sn(n);
            on = !1;
        }
    }
    function sn(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, fn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var dn = {};
    function vn(n, r, t, e, u) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: u
        };
    }
    function bn(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, a = n.e, i = n.f;
        function o(n) {
            return A2(nn, o, {
                $: 5,
                b: function(r) {
                    var o = r.a;
                    return 0 === r.$ ? A3(u, t, o, n) : a && i ? A4(e, t, o.i, o.j, n) : A3(e, t, a ? o.i : o.j, n);
                }
            });
        }
        return t.h = tn(A2(nn, o, n.b));
    }
    var ln, hn = F2(function(n, r) {
        return X(function(t) {
            n.g(r), t(V(0));
        });
    }), $n = F2(function(n, r) {
        return A2(an, n.h, {
            $: 0,
            a: r
        });
    });
    function gn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function pn(n) {
        return {
            $: 2,
            m: n
        };
    }
    function mn(n, r, t) {
        var e = {};
        for(var u in yn(!0, r, e, null), yn(!1, t, e, null), n)un(n[u], {
            $: "fx",
            a: e[u] || {
                i: b,
                j: b
            }
        });
    }
    function yn(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, a = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.q)n = r.p(n);
                        return n;
                    }
                    return A2(n ? dn[r].e : dn[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: b,
                        j: b
                    }, n ? t.i = l(r, t.i) : t.j = l(r, t.j), t;
                }(n, a, t[u]));
            case 2:
                for(var i = r.m; i.b; i = i.b)yn(n, i.a, t, e);
                return;
            case 3:
                return void yn(n, r.o, t, {
                    p: r.n,
                    q: e
                });
        }
    }
    var wn = "undefined" != typeof document ? document : {};
    function xn(n, r) {
        n.appendChild(r);
    }
    function An(n) {
        return {
            $: 0,
            a: n
        };
    }
    var jn = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 1,
                c: r,
                d: Tn(t),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0);
    F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 2,
                c: r,
                d: Tn(t),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0);
    var kn, _n = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), Ln = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), En = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), Nn = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    });
    function Tn(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, a = t.o;
            if ("a2" !== e) {
                var i = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? On(i, u, a) : i[u] = a;
            } else "className" === u ? On(r, u, a) : r[u] = a;
        }
        return r;
    }
    function On(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function Rn(n, r) {
        var t = n.$;
        if (5 === t) return Rn(n.k || (n.k = n.m()), r);
        if (0 === t) return wn.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var a = {
                j: u,
                p: r
            };
            return (i = Rn(e, a)).elm_event_node_ref = a, i;
        }
        if (3 === t) return Cn(i = n.h(n.g), r, n.d), i;
        var i = n.f ? wn.createElementNS(n.f, n.c) : wn.createElement(n.c);
        ln && "a" == n.c && i.addEventListener("click", ln(i)), Cn(i, r, n.d);
        for(var o = n.e, c = 0; o.length > c; c++)xn(i, Rn(1 === t ? o[c] : o[c].b, r));
        return i;
    }
    function Cn(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? Pn(n, u) : "a0" === e ? Jn(n, r, u) : "a3" === e ? Mn(n, u) : "a4" === e ? Sn(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function Pn(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function Mn(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function Sn(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, a = e.o;
            void 0 !== a ? n.setAttributeNS(u, t, a) : n.removeAttributeNS(u, t);
        }
    }
    function Jn(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var a = t[u], i = e[u];
            if (a) {
                if (i) {
                    if (i.q.$ === a.$) {
                        i.q = a;
                        continue;
                    }
                    n.removeEventListener(u, i);
                }
                i = Un(r, a), n.addEventListener(u, i, kn && {
                    passive: 2 > vt(a)
                }), e[u] = i;
            } else n.removeEventListener(u, i), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                kn = !0;
            }
        }));
    } catch (n) {}
    function Un(n, r) {
        function t(r) {
            var e = t.q, u = I(e.a, r);
            if (ot(u)) {
                for(var a, i = vt(e), o = u.a, c = i ? 3 > i ? o.a : o.M : o, f = 1 == i ? o.b : 3 == i && o.cT, s = (f && r.stopPropagation(), (2 == i ? o.b : 3 == i && o.cO) && r.preventDefault(), n); a = s.j;){
                    if ("function" == typeof a) c = a(c);
                    else for(var d = a.length; d--;)c = a[d](c);
                    s = s.p;
                }
                s(c, f);
            }
        }
        return t.q = r, t;
    }
    function Fn(n, r) {
        return n.$ == r.$ && Z(n.a, r.a);
    }
    function Bn(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function Dn(n, r, t, e) {
        if (n !== r) {
            var u = n.$, a = r.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void Bn(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), a = 1;
            }
            switch(a){
                case 5:
                    for(var i = n.l, o = r.l, c = i.length, f = c === o.length; f && c--;)f = i[c] === o[c];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return Dn(n.k, r.k, s, 0), void (s.length > 0 && Bn(t, 1, e, s));
                case 4:
                    for(var d = n.j, v = r.j, b = !1, l = n.k; 4 === l.$;)b = !0, "object" != typeof d ? d = [
                        d,
                        l.j
                    ] : d.push(l.j), l = l.k;
                    for(var h = r.k; 4 === h.$;)b = !0, "object" != typeof v ? v = [
                        v,
                        h.j
                    ] : v.push(h.j), h = h.k;
                    return b && d.length !== v.length ? void Bn(t, 0, e, r) : ((b ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(d, v) : d === v) || Bn(t, 2, e, v), void Dn(l, h, t, e + 1));
                case 0:
                    return void (n.a !== r.a && Bn(t, 3, e, r.a));
                case 1:
                    return void Hn(n, r, t, e, qn);
                case 2:
                    return void Hn(n, r, t, e, Gn);
                case 3:
                    if (n.h !== r.h) return void Bn(t, 0, e, r);
                    var $ = In(n.d, r.d);
                    $ && Bn(t, 4, e, $);
                    var g = r.i(n.g, r.g);
                    return void (g && Bn(t, 5, e, g));
            }
        }
    }
    function Hn(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var a = In(n.d, r.d);
            a && Bn(t, 4, e, a), u(n, r, t, e);
        } else Bn(t, 0, e, r);
    }
    function In(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var a = n[u], i = r[u];
                a === i && "value" !== u && "checked" !== u || "a0" === t && Fn(a, i) || ((e = e || {})[u] = i);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var o = In(n[u], r[u] || {}, u);
            o && ((e = e || {})[u] = o);
        }
        for(var c in r)c in n || ((e = e || {})[c] = r[c]);
        return e;
    }
    function qn(n, r, t, e) {
        var u = n.e, a = r.e, i = u.length, o = a.length;
        i > o ? Bn(t, 6, e, {
            v: o,
            i: i - o
        }) : o > i && Bn(t, 7, e, {
            v: i,
            e: a
        });
        for(var c = o > i ? i : o, f = 0; c > f; f++){
            var s = u[f];
            Dn(s, a[f], t, ++e), e += s.b || 0;
        }
    }
    function Gn(n, r, t, e) {
        for(var u = [], a = {}, i = [], o = n.e, c = r.e, f = o.length, s = c.length, d = 0, v = 0, b = e; f > d && s > v;){
            var l = (_ = o[d]).a, h = (L = c[v]).a, $ = _.b, g = L.b, p = void 0, m = void 0;
            if (l !== h) {
                var y = o[d + 1], w = c[v + 1];
                if (y) {
                    var x = y.a, A = y.b;
                    m = h === x;
                }
                if (w) {
                    var j = w.a, k = w.b;
                    p = l === j;
                }
                if (p && m) Dn($, k, u, ++b), Yn(a, u, l, g, v, i), b += $.b || 0, Zn(a, u, l, A, ++b), b += A.b || 0, d += 2, v += 2;
                else if (p) b++, Yn(a, u, h, g, v, i), Dn($, k, u, b), b += $.b || 0, d += 1, v += 2;
                else if (m) Zn(a, u, l, $, ++b), b += $.b || 0, Dn(A, g, u, ++b), b += A.b || 0, d += 2, v += 1;
                else {
                    if (!y || x !== j) break;
                    Zn(a, u, l, $, ++b), Yn(a, u, h, g, v, i), b += $.b || 0, Dn(A, k, u, ++b), b += A.b || 0, d += 2, v += 2;
                }
            } else Dn($, g, u, ++b), b += $.b || 0, d++, v++;
        }
        for(; f > d;){
            var _;
            b++, Zn(a, u, (_ = o[d]).a, $ = _.b, b), b += $.b || 0, d++;
        }
        for(; s > v;){
            var L, E = E || [];
            Yn(a, u, (L = c[v]).a, L.b, void 0, E), v++;
        }
        (u.length > 0 || i.length > 0 || E) && Bn(t, 8, e, {
            w: u,
            x: i,
            y: E
        });
    }
    var zn = "_elmW6BL";
    function Yn(n, r, t, e, u, a) {
        var i = n[t];
        if (!i) return a.push({
            r: u,
            A: i = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = i);
        if (1 === i.c) {
            a.push({
                r: u,
                A: i
            }), i.c = 2;
            var o = [];
            return Dn(i.z, e, o, i.r), i.r = u, void (i.s.s = {
                w: o,
                A: i
            });
        }
        Yn(n, r, t + zn, e, u, a);
    }
    function Zn(n, r, t, e, u) {
        var a = n[t];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var i = [];
                return Dn(e, a.z, i, u), void Bn(r, 9, u, {
                    w: i,
                    A: a
                });
            }
            Zn(n, r, t + zn, e, u);
        } else {
            var o = Bn(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: o
            };
        }
    }
    function Wn(n, r, t, e) {
        Kn(n, r, t, 0, 0, r.b, e);
    }
    function Kn(n, r, t, e, u, a, i) {
        for(var o = t[e], c = o.r; c === u;){
            var f = o.$;
            if (1 === f) Wn(n, r.k, o.s, i);
            else if (8 === f) o.t = n, o.u = i, (s = o.s.w).length > 0 && Kn(n, r, s, 0, u, a, i);
            else if (9 === f) {
                o.t = n, o.u = i;
                var s, d = o.s;
                d && (d.A.s = n, (s = d.w).length > 0 && Kn(n, r, s, 0, u, a, i));
            } else o.t = n, o.u = i;
            if (!(o = t[++e]) || (c = o.r) > a) return e;
        }
        var v = r.$;
        if (4 === v) {
            for(var b = r.k; 4 === b.$;)b = b.k;
            return Kn(n, b, t, e, u + 1, a, n.elm_event_node_ref);
        }
        for(var l = r.e, h = n.childNodes, $ = 0; l.length > $; $++){
            u++;
            var g = 1 === v ? l[$] : l[$].b, p = u + (g.b || 0);
            if (!(u > c || c > p || (o = t[e = Kn(h[$], g, t, e, u, p, i)]) && (c = o.r) <= a)) return e;
            u = p;
        }
        return e;
    }
    function Qn(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, a = Vn(u, e);
            u === n && (n = a);
        }
        return n;
    }
    function Vn(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = Rn(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return Cn(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return Qn(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var a = (t = r.s).e, i = n.childNodes[e = t.v]; a.length > e; e++)n.insertBefore(Rn(a[e], r.u), i);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var o = t.A;
                return void 0 !== o.r && n.parentNode.removeChild(n), o.s = Qn(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = wn.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                xn(t, 2 === u.c ? u.s : Rn(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = Qn(n, t.w);
                    for(var u = t.x, a = 0; u.length > a; a++){
                        var i = u[a], o = i.A, c = 2 === o.c ? o.s : Rn(o.z, r.u);
                        n.insertBefore(c, n.childNodes[i.r]);
                    }
                    return e && xn(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                u(10);
        }
    }
    function Xn(n) {
        if (3 === n.nodeType) return An(n.textContent);
        if (1 !== n.nodeType) return An("");
        for(var r = b, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = l(A2(Nn, u.name, u.value), r);
        }
        var a = n.tagName.toLowerCase(), i = b, o = n.childNodes;
        for(e = o.length; e--;)i = l(Xn(o[e]), i);
        return A3(jn, a, r, i);
    }
    var nr = F4(function(n, r, t, e) {
        return function(n, r, t, e, a, i) {
            var o = A2(H, n, r ? r.flags : void 0);
            ot(o) || u(2);
            var c = {}, f = (o = t(o.a)).a, s = i(v, f), d = function(n, r) {
                var t;
                for(var e in dn){
                    var u = dn[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = bn(u, r);
                }
                return t;
            }(c, v);
            function v(n, r) {
                s(f = (o = A2(e, n, f)).a, r), mn(c, o.b, a(f));
            }
            return mn(c, o.b, a(f)), d ? {
                ports: d
            } : {};
        }(r, e, n.eA, n.e7, n.e2, function(r, t) {
            var u = n.e8, a = e.node, i = Xn(a);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (tr(e), r(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (r(n), 2 === t && (t = 1)) : (0 === t && tr(e), t = 2);
                };
            }(t, function(n) {
                var t = u(n), e = function(n, r) {
                    var t = [];
                    return Dn(n, r, t, 0), t;
                }(i, t);
                a = function(n, r, t, e) {
                    return 0 === t.length ? n : (Wn(n, r, t, e), Qn(n, t));
                }(a, i, e, r), i = t;
            });
        });
    }), rr = "undefined" != typeof cancelAnimationFrame ? cancelAnimationFrame : function(n) {
        clearTimeout(n);
    }, tr = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    };
    var er = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, ur = "undefined" != typeof document ? document : er, ar = "undefined" != typeof window ? window : er, ir = F3(function(n, r, t) {
        return en(X(function() {
            function e(n) {
                tn(t(n));
            }
            return n.addEventListener(r, e, kn && {
                passive: !0
            }), function() {
                n.removeEventListener(r, e);
            };
        }));
    }), or = F2(function(n, r) {
        var t = I(n, r);
        return ot(t) ? yr(t.a) : wr;
    }), cr = h, fr = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, a = A3(n, t.b, t.c, A3(fr, n, r, t.e));
            n = u, r = a, t = e;
        }
    }), sr = function(n) {
        return A3(fr, F3(function(n, r, t) {
            return A2(cr, f(n, r), t);
        }), b, n);
    }, dr = 1, vr = 2, br = 0, lr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, hr = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), $r = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), gr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), pr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, mr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, yr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, wr = {
        $: 1
    }, xr = k, Ar = K, jr = N, kr = F2(function(n, r) {
        return A2(A, n, function(n) {
            for(var r = []; n.b; n = n.b)r.push(n.a);
            return r;
        }(r));
    }), _r = F2(function(n, r) {
        return $(A2(x, n, r));
    }), Lr = function(n) {
        return A2(kr, "\n    ", A2(_r, "\n", n));
    }, Er = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, a = A2(n, t.a, r);
            n = u, r = a, t = e;
        }
    }), Nr = function(n) {
        return A3(Er, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, Tr = g, Or = F3(function(n, r, t) {
        for(;;){
            if (o(n, r) >= 1) return t;
            var e = n, u = r - 1, a = A2(cr, r, t);
            n = e, r = u, t = a;
        }
    }), Rr = F2(function(n, r) {
        return A3(Or, n, r, b);
    }), Cr = F2(function(n, r) {
        return A3(Tr, n, A2(Rr, 0, Nr(r) - 1), r);
    }), Pr = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, Mr = function(n) {
        var r = Pr(n);
        return r >= 97 && 122 >= r;
    }, Sr = function(n) {
        var r = Pr(n);
        return 90 >= r && r >= 65;
    }, Jr = function(n) {
        return Mr(n) || Sr(n) || function(n) {
            var r = Pr(n);
            return 57 >= r && r >= 48;
        }(n);
    }, Ur = function(n) {
        return A3(Er, cr, b, n);
    }, Fr = F2(function(n, r) {
        return "\n\n(" + jr(n + 1) + ") " + Lr(Br(r));
    }), Br = function(n) {
        return A2(Dr, n, b);
    }, Dr = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var t = n.a, e = n.b, u = function() {
                    var n, r, e = (r = (n = t).charCodeAt(0)) ? yr(55296 > r || r > 56319 ? f(n[0], n.slice(1)) : f(n[0] + n[1], n.slice(2))) : wr;
                    if (1 === e.$) return !1;
                    var u, a = e.a, i = a.b;
                    return (Mr(u = a.a) || Sr(u)) && A2(xr, Jr, i);
                }();
                n = e, r = A2(cr, u ? "." + t : "['" + t + "']", r);
                continue n;
            case 1:
                e = n.b;
                var a = "[" + jr(n.a) + "]";
                n = e, r = A2(cr, a, r);
                continue n;
            case 2:
                var i = n.a;
                if (i.b) {
                    if (i.b.b) {
                        var o = (r.b ? "The Json.Decode.oneOf at json" + A2(kr, "", Ur(r)) : "Json.Decode.oneOf") + " failed in the following " + jr(Nr(i)) + " ways:";
                        return A2(kr, "\n\n", A2(cr, o, A2(Cr, Fr, i)));
                    }
                    n = e = i.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + (r.b ? " at json" + A2(kr, "", Ur(r)) : "!");
            default:
                var c = n.a, s = n.b;
                return (o = r.b ? "Problem with the value at json" + A2(kr, "", Ur(r)) + ":\n\n    " : "Problem with the given value:\n\n") + Lr(A2(Ar, 4, s)) + "\n\n" + c;
        }
    }), Hr = 32, Ir = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), qr = [], Gr = p, zr = F2(function(n, r) {
        return w(r) / w(n);
    }), Yr = function(n) {
        return n;
    }, Zr = Gr(A2(zr, 2, Hr)), Wr = A4(Ir, 0, Zr, qr, qr), Kr = t, Qr = m, Vr = function(n) {
        return n.length;
    }, Xr = F2(function(n, r) {
        return o(n, r) > 0 ? n : r;
    }), nt = e, rt = F2(function(n, r) {
        for(;;){
            var t = A2(nt, Hr, n), e = t.b, u = A2(cr, {
                $: 0,
                a: t.a
            }, r);
            if (!e.b) return Ur(u);
            n = e, r = u;
        }
    }), tt = function(n) {
        return n.a;
    }, et = F2(function(n, r) {
        for(;;){
            var t = Gr(r / Hr);
            if (1 === t) return A2(nt, Hr, n).a;
            n = A2(rt, n, b), r = t;
        }
    }), ut = F2(function(n, r) {
        if (r.g) {
            var t = r.g * Hr, e = Qr(A2(zr, Hr, t - 1)), u = n ? Ur(r.j) : r.j, a = A2(et, u, r.g);
            return A4(Ir, Vr(r.i) + t, A2(Xr, 5, e * Zr), a, r.i);
        }
        return A4(Ir, Vr(r.i), Zr, qr, r.i);
    }), at = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(ut, !1, {
                j: e,
                g: t / Hr | 0,
                i: u
            });
            var a = {
                $: 1,
                a: A3(Kr, Hr, r, n)
            };
            r -= Hr, e = A2(cr, a, e);
        }
    }), it = F2(function(n, r) {
        if (n > 0) {
            var t = n % Hr;
            return A5(at, r, n - t - Hr, n, b, A3(Kr, t, n - t, r));
        }
        return Wr;
    }), ot = function(n) {
        return !n.$;
    }, ct = J, ft = U, st = F, dt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vt = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, bt = function(n) {
        return n;
    }, lt = F6(function(n, r, t, e, u, a) {
        return {
            df: a,
            dj: r,
            eV: e,
            dE: t,
            dI: n,
            dJ: u
        };
    }), ht = _, $t = function(n) {
        return n.length;
    }, gt = j, pt = F2(function(n, r) {
        return 1 > n ? r : A3(gt, n, $t(r), r);
    }), mt = E, yt = function(n) {
        return "" === n;
    }, wt = F2(function(n, r) {
        return 1 > n ? "" : A3(gt, 0, n, r);
    }), xt = function(n) {
        for(var r = 0, t = n.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, u = e; n.length > u; ++u){
            var a = n.charCodeAt(u);
            if (48 > a || a > 57) return wr;
            r = 10 * r + a - 48;
        }
        return u == e ? wr : yr(45 == t ? -r : r);
    }, At = F5(function(n, r, t, e, u) {
        if (yt(u) || A2(ht, "@", u)) return wr;
        var a = A2(mt, ":", u);
        if (a.b) {
            if (a.b.b) return wr;
            var i = a.a, o = xt(A2(pt, i + 1, u));
            if (1 === o.$) return wr;
            var c = o;
            return yr(A6(lt, n, A2(wt, i, u), c, r, t, e));
        }
        return yr(A6(lt, n, u, wr, r, t, e));
    }), jt = F4(function(n, r, t, e) {
        if (yt(e)) return wr;
        var u = A2(mt, "/", e);
        if (u.b) {
            var a = u.a;
            return A5(At, n, A2(pt, a, e), r, t, A2(wt, a, e));
        }
        return A5(At, n, "/", r, t, e);
    }), kt = F3(function(n, r, t) {
        if (yt(t)) return wr;
        var e = A2(mt, "?", t);
        if (e.b) {
            var u = e.a;
            return A4(jt, n, yr(A2(pt, u + 1, t)), r, A2(wt, u, t));
        }
        return A4(jt, n, wr, r, t);
    }), _t = F2(function(n, r) {
        if (yt(r)) return wr;
        var t = A2(mt, "#", r);
        if (t.b) {
            var e = t.a;
            return A3(kt, n, yr(A2(pt, e + 1, r)), A2(wt, e, r));
        }
        return A3(kt, n, wr, r);
    }), Lt = L, Et = V, Nt = Et(0), Tt = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, a = e.b;
            if (a.b) {
                var i = a.a, o = a.b;
                if (o.b) {
                    var c = o.a, f = o.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, u, A2(n, i, A2(n, c, A2(n, f.a, t > 500 ? A3(Er, n, r, Ur(s)) : A4(Tt, n, r, t + 1, s)))));
                    }
                    return A2(n, u, A2(n, i, A2(n, c, r)));
                }
                return A2(n, u, A2(n, i, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), Ot = F3(function(n, r, t) {
        return A4(Tt, n, r, 0, t);
    }), Rt = F2(function(n, r) {
        return A3(Ot, F2(function(r, t) {
            return A2(cr, n(r), t);
        }), b, r);
    }), Ct = nn, Pt = F2(function(n, r) {
        return A2(Ct, function(r) {
            return Et(n(r));
        }, r);
    }), Mt = F3(function(n, r, t) {
        return A2(Ct, function(r) {
            return A2(Ct, function(t) {
                return Et(A2(n, r, t));
            }, t);
        }, r);
    }), St = function(n) {
        return A3(Ot, Mt(cr), Et(b), n);
    }, Jt = hn, Ut = F2(function(n, r) {
        var t = r;
        return en(A2(Ct, Jt(n), t));
    });
    dn.Task = vn(Nt, F3(function(n, r) {
        return A2(Pt, function() {
            return 0;
        }, St(A2(Rt, Ut(n), r)));
    }), F3(function() {
        return Et(0);
    }), F2(function(n, r) {
        return A2(Pt, n, r);
    })), gn("Task");
    var Ft = nr, Bt = M, Dt = F3(function(n, r, t) {
        return {
            u: r,
            x: n,
            cp: t
        };
    }), Ht = F2(function(n, r) {
        return {
            cx: r,
            du: n
        };
    }), It = F2(function(n, r) {
        return r.b ? A3(Ot, cr, r, n) : n;
    }), qt = function(n) {
        return A3(Ot, It, b, n);
    }, Gt = F4(function(n, r, t, e) {
        return {
            ec: r,
            ed: t,
            ej: n,
            ek: e
        };
    }), zt = F2(function(n, r) {
        return {
            dv: n,
            e$: r
        };
    }), Yt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Zt = function(n) {
        return {
            $: 3,
            b: n
        };
    }, Wt = O, Kt = P, Qt = A2(ct, function(n) {
        return Nr(n) ? dt(n) : Yt("There must be at least one role in your config.");
    }, Zt(A3(st, F2(function(n, r) {
        return {
            d7: r,
            dv: n
        };
    }), A2(Bt, "name", Kt), A2(ft, Yr, A2(Bt, "baseSalary", Wt))))), Vt = A2(ct, function(n) {
        return Nr(n) ? dt(n) : Yt("There must be at least one career in your config.");
    }, Zt(A3(st, zt, A2(Bt, "name", Kt), A2(Bt, "roles", Qt)))), Xt = R, ne = A2(ct, function(n) {
        return Nr(n) ? dt(n) : Yt("There must be at least one country in your config.");
    }, Zt(A3(st, F2(function(n, r) {
        return {
            eh: r,
            dv: n
        };
    }), A2(Bt, "name", Kt), A2(Bt, "compressed_cost_of_living", Xt)))), re = D, te = A5(re, Gt, A2(Bt, "countries", ne), A2(Bt, "careers", Vt), A2(Bt, "careers_updated", Kt), A2(Bt, "countries_updated", Kt)), ee = H, ue = F2(function(n, r) {
        return r.$ ? n(r.a) : r.a;
    }), ae = F2(function(n, r) {
        return r.$ ? lr(n) : pr(r.a);
    }), ie = function(n) {
        return n.b ? yr(n.a) : wr;
    }, oe = {
        $: -2
    }, ce = oe, fe = ce, se = F4(function(n, r, t, e) {
        return {
            an: e,
            Y: r,
            ab: n,
            aA: t
        };
    }), de = {
        aP: A4(se, 0, 0, 0, 0),
        A: 2,
        cc: A4(se, 0, 0, 0, 0)
    }, ve = c, be = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return wr;
            var t = r.c, e = r.d, u = r.e;
            switch(A2(ve, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return yr(t);
                default:
                    r = u;
                    continue n;
            }
        }
    }), le = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), he = F2(function(n, r) {
        return function(t) {
            return r(A2(le, b, A2(be, n, t)));
        };
    }), $e = F2(function(n, r) {
        return A3(Ot, F2(function(r, t) {
            return n(r) ? A2(cr, r, t) : t;
        }), b, r);
    }), ge = F2(function(n, r) {
        return ie(A2($e, function(r) {
            return a(r.dv, n);
        }, r));
    }), pe = F2(function(n, r) {
        return r.$ ? lr(r.a) : pr(n(r.a));
    }), me = F4(function(n, r, t, e) {
        var u = r, a = t, i = e;
        return function(r) {
            return A3(n, u(r), a(r), i(r));
        };
    }), ye = pn(b), we = F5(function(n, r, t, e, u) {
        return {
            W: e,
            _: t,
            Q: r,
            G: u,
            ad: n
        };
    }), xe = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(cr, n.a, xe(n.b)) : b;
    }, Ae = F2(function(n, r) {
        return yr(1 === r.$ ? $([
            n
        ]) : A2(cr, n, r.a));
    }), je = function(n) {
        try {
            return yr(decodeURIComponent(n));
        } catch (n) {
            return wr;
        }
    }, ke = F5(function(n, r, t, e, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), _e = F5(function(n, r, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(ke, n, r, t, e, u);
            var a = e.d;
            return i = e.e, A5(ke, 0, e.b, e.c, A5(ke, 1, a.b, a.c, a.d, a.e), A5(ke, 1, r, t, i, u));
        }
        var i, o = u.b, c = u.c, f = u.d, s = u.e;
        return -1 !== e.$ || e.a ? A5(ke, n, o, c, A5(ke, 0, r, t, e, f), s) : A5(ke, 0, r, t, A5(ke, 1, e.b, e.c, e.d, i = e.e), A5(ke, 1, o, c, f, s));
    }), Le = F3(function(n, r, t) {
        if (-2 === t.$) return A5(ke, 0, n, r, oe, oe);
        var e = t.a, u = t.b, a = t.c, i = t.d, o = t.e;
        switch(A2(ve, n, u)){
            case 0:
                return A5(_e, e, u, a, A3(Le, n, r, i), o);
            case 1:
                return A5(ke, e, u, r, i, o);
            default:
                return A5(_e, e, u, a, i, A3(Le, n, r, o));
        }
    }), Ee = F3(function(n, r, t) {
        var e = A3(Le, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(ke, 1, e.b, e.c, e.d, e.e);
    }), Ne = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, t = n.e;
                return i = t.b, o = t.c, e = t.d, s = t.e, A5(ke, 1, n.b, n.c, A5(ke, 0, r.b, r.c, r.d, r.e), A5(ke, 0, i, o, e, s));
            }
            var e, u = n.d, a = n.e, i = a.b, o = a.c, c = (e = a.d).d, f = e.e, s = a.e;
            return A5(ke, 0, e.b, e.c, A5(ke, 1, n.b, n.c, A5(ke, 0, u.b, u.c, u.d, u.e), c), A5(ke, 1, i, o, f, s));
        }
        return n;
    }, Te = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, t = n.e;
                return f = t.b, s = t.c, d = t.d, v = t.e, A5(ke, 1, e = n.b, u = n.c, A5(ke, 0, r.b, r.c, r.d, o = r.e), A5(ke, 0, f, s, d, v));
            }
            var e = n.b, u = n.c, a = n.d, i = a.d, o = a.e, c = n.e, f = c.b, s = c.c, d = c.d, v = c.e;
            return A5(ke, 0, a.b, a.c, A5(ke, 1, i.b, i.c, i.d, i.e), A5(ke, 1, e, u, o, A5(ke, 0, f, s, d, v)));
        }
        return n;
    }, Oe = F7(function(n, r, t, e, u, a, i) {
        if (-1 !== a.$ || a.a) {
            n: for(;;){
                if (-1 === i.$ && 1 === i.a) {
                    if (-1 === i.d.$) {
                        if (1 === i.d.a) return Te(r);
                        break n;
                    }
                    return Te(r);
                }
                break n;
            }
            return r;
        }
        return A5(ke, t, a.b, a.c, a.d, A5(ke, 0, e, u, a.e, i));
    }), Re = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, t = n.b, e = n.c, u = n.d, a = u.d, i = n.e;
            if (1 === u.a) {
                if (-1 !== a.$ || a.a) {
                    var o = Ne(n);
                    if (-1 === o.$) {
                        var c = o.e;
                        return A5(_e, o.a, o.b, o.c, Re(o.d), c);
                    }
                    return oe;
                }
                return A5(ke, r, t, e, Re(u), i);
            }
            return A5(ke, r, t, e, Re(u), i);
        }
        return oe;
    }, Ce = F2(function(n, r) {
        if (-2 === r.$) return oe;
        var t = r.a, e = r.b, u = r.c, a = r.d, i = r.e;
        if (0 > o(n, e)) {
            if (-1 === a.$ && 1 === a.a) {
                var c = a.d;
                if (-1 !== c.$ || c.a) {
                    var f = Ne(r);
                    if (-1 === f.$) {
                        var s = f.e;
                        return A5(_e, f.a, f.b, f.c, A2(Ce, n, f.d), s);
                    }
                    return oe;
                }
                return A5(ke, t, e, u, A2(Ce, n, a), i);
            }
            return A5(ke, t, e, u, A2(Ce, n, a), i);
        }
        return A2(Pe, n, A7(Oe, n, r, t, e, u, a, i));
    }), Pe = F2(function(n, r) {
        if (-1 === r.$) {
            var t = r.a, e = r.b, u = r.c, i = r.d, o = r.e;
            if (a(n, e)) {
                var c = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(o);
                return -1 === c.$ ? A5(_e, t, c.b, c.c, i, Re(o)) : oe;
            }
            return A5(_e, t, e, u, i, A2(Ce, n, o));
        }
        return oe;
    }), Me = F2(function(n, r) {
        var t = A2(Ce, n, r);
        return -1 !== t.$ || t.a ? t : A5(ke, 1, t.b, t.c, t.d, t.e);
    }), Se = F3(function(n, r, t) {
        var e = r(A2(be, n, t));
        return e.$ ? A2(Me, n, t) : A3(Ee, n, e.a, t);
    }), Je = F2(function(n, r) {
        var t = A2(_r, "=", n);
        if (t.b && t.b.b && !t.b.b.b) {
            var e = t.b.a, u = je(t.a);
            if (1 === u.$) return r;
            var a = u.a, i = je(e);
            return 1 === i.$ ? r : A3(Se, a, Ae(i.a), r);
        }
        return r;
    }), Ue = F2(function(n, r) {
        var t;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var r = n.a, t = r.Q;
                    if (t.b) {
                        if ("" !== t.a || t.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return yr(r.G);
                    }
                    return yr(r.G);
                }
                return wr;
            }
        }(n(A5(we, b, function(n) {
            var r = A2(_r, "/", n);
            return xe(r.b && "" === r.a ? r.b : r);
        }(r.eV), 1 === (t = r.dJ).$ ? ce : A3(Ot, Je, ce, A2(_r, "&", t.a)), r.df, bt)));
    }), Fe = F2(function(n, r) {
        return qt(A2(Rt, n, r));
    }), Be = F2(function(n, r) {
        var t = n, e = r;
        return function(n) {
            return A2(Fe, e, t(n));
        };
    }), De = F2(function(n, r) {
        return A2(Be, n, function(n) {
            var r = n;
            return function(n) {
                var t = n._;
                return $([
                    A5(we, n.ad, n.Q, t, n.W, (0, n.G)(r(t)))
                ]);
            };
        }(r));
    }), He = function(n) {
        return A2(he, n, function(n) {
            return n.b && !n.b.b ? yr(n.a) : wr;
        });
    }, Ie = function(n) {
        return $([
            n
        ]);
    }, qe = A2(Ot, F2(function(n, r) {
        return 1 === n.$ ? r : A2(cr, n.a, r);
    }), b), Ge = function(n) {
        return {
            $: 6,
            a: n
        };
    }, ze = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ye = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ze = function(n) {
        return {
            $: 2,
            a: n
        };
    }, We = pn, Ke = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), Qe = F2(function(n, r) {
        if (-2 === r.$) return oe;
        var t = r.b, e = r.d, u = r.e;
        return A5(ke, r.a, t, A2(n, t, r.c), A2(Qe, n, e), A2(Qe, n, u));
    }), Ve = F2(function(n, r) {
        return A2(Ke, function(r) {
            return a(r, n);
        }, r);
    }), Xe = We(b), nu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ru = F3(function(n, r, t) {
        return {
            cK: t,
            dL: r,
            dU: n
        };
    }), tu = Et(A3(ru, b, wr, 0)), eu = function(n) {
        return X(function(r) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, r(V(0));
        });
    }, uu = X(function(n) {
        n(V(Date.now()));
    }), au = X(function(n) {
        var r = tr(function() {
            n(V(Date.now()));
        });
        return function() {
            rr(r);
        };
    }), iu = $n, ou = en, cu = F3(function(n, r, t) {
        var e = t.dL, u = t.cK, a = f(e, r);
        return 1 === a.a.$ ? a.b.b ? A2(Ct, function(n) {
            return A2(Ct, function(t) {
                return Et(A3(ru, r, yr(n), t));
            }, uu);
        }, ou(A2(Ct, iu(n), au))) : tu : a.b.b ? Et(A3(ru, r, e, u)) : A2(Ct, function() {
            return tu;
        }, eu(a.a.a));
    }), fu = bt, su = F3(function(n, r, t) {
        var e = t.dU, u = t.cK, a = function(t) {
            return A2(Jt, n, (0, t.a)(t.$ ? r - u : fu(r)));
        };
        return A2(Ct, function(n) {
            return A2(Ct, function() {
                return Et(A3(ru, e, yr(n), r));
            }, St(A2(Rt, a, e)));
        }, ou(A2(Ct, iu(n), au)));
    }), du = F3(function(n, r, t) {
        return n(r(t));
    });
    dn["Browser.AnimationManager"] = vn(tu, cu, su, 0, F2(function(n, r) {
        return r.$ ? {
            $: 1,
            a: A2(du, n, r.a)
        } : nu(A2(du, n, r.a));
    }));
    var vu = gn("Browser.AnimationManager"), bu = function(n) {
        return vu(nu(n));
    }, lu = F2(function(n, r) {
        var t = n, e = A2(Qe, F2(function(n, r) {
            switch(r.n){
                case 1:
                    return d(r, {
                        n: 3
                    });
                case 2:
                    return d(r, {
                        n: 0
                    });
                default:
                    return r;
            }
        }), t);
        return A2(Ke, function(n) {
            return A2(Ve, n.b.n, $([
                1,
                2
            ]));
        }, sr(t)) ? bu(function() {
            return r(e);
        }) : Xe;
    }), hu = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), $u = F2(function(n, r) {
        return {
            dD: r,
            dU: n
        };
    }), gu = Et(A2($u, b, ce)), pu = function(n) {
        return f(v(n.a ? "w_" : "d_", n.b), n);
    }, mu = function(n) {
        return A3(Er, F2(function(n, r) {
            return A3(Ee, n.a, n.b, r);
        }), ce, n);
    }, yu = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, u = n, a = A3(n, t.b, t.c, A3(yu, n, r, t.d));
            n = u, r = a, t = e;
        }
    }), wu = F6(function(n, r, t, e, u, a) {
        var i = A3(yu, F3(function(e, u, a) {
            n: for(;;){
                var i = a.a, c = a.b;
                if (i.b) {
                    var s = i.a, d = s.a, v = s.b, b = i.b;
                    if (0 > o(d, e)) {
                        a = f(b, A3(n, d, v, c));
                        continue n;
                    }
                    return o(d, e) > 0 ? f(i, A3(t, e, u, c)) : f(b, A4(r, d, v, u, c));
                }
                return f(i, A3(t, e, u, c));
            }
        }), f(sr(e), a), u), c = i.a, s = i.b;
        return A3(Er, F2(function(r, t) {
            return A3(n, r.a, r.b, t);
        }), s, c);
    }), xu = F2(function(n, r) {
        return {
            de: r,
            dp: n
        };
    }), Au = F3(function(n, r, t) {
        return A2(Pt, function(n) {
            return f(r, n);
        }, A3(ir, t.a ? ar : ur, t.b, function(t) {
            return A2(iu, n, A2(xu, r, t));
        }));
    }), ju = F2(function(n, r) {
        return A3(yu, Ee, r, n);
    }), ku = F3(function(n, r, t) {
        var e = F3(function(r, t, e) {
            var u = e.c;
            return s(e.a, e.b, A2(cr, A3(Au, n, r, t), u));
        }), u = F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return s(A2(cr, r, t.a), e, u);
        }), a = F4(function(n, r, t, e) {
            var u = e.c;
            return s(e.a, A3(Ee, n, r, e.b), u);
        }), i = A2(Rt, pu, r), o = A6(wu, u, a, e, t.dD, mu(i), s(b, ce, b)), c = o.b, f = o.c;
        return A2(Ct, function(n) {
            return Et(A2($u, i, A2(ju, c, mu(n))));
        }, A2(Ct, function() {
            return St(f);
        }, St(A2(Rt, eu, o.a))));
    }), _u = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(cr, e.a, t);
    }), Lu = F2(function(n, r) {
        return A3(Ot, _u(n), b, r);
    }), Eu = F3(function(n, r, t) {
        var e = r.dp, u = r.de, i = A2(Lu, function(n) {
            var r = n.b.c;
            return a(n.a, e) ? A2(or, r, u) : wr;
        }, t.dU);
        return A2(Ct, function() {
            return Et(t);
        }, St(A2(Rt, Jt(n), i)));
    });
    dn["Browser.Events"] = vn(gu, ku, Eu, 0, F2(function(n, r) {
        return A3(hu, r.a, r.b, A2(ft, n, r.c));
    }));
    var Nu, Tu, Ou = gn("Browser.Events"), Ru = F3(function(n, r, t) {
        return Ou(A3(hu, n, r, t));
    }), Cu = A2(Ru, 0, "click"), Pu = F2(function(n, r) {
        return d(r, {
            A: n
        });
    }), Mu = F2(function(n, r) {
        switch(n.A){
            case 0:
                return bu(function() {
                    return r(A2(Pu, 1, n));
                });
            case 1:
                return Cu(dt(r(A2(Pu, 2, n))));
            default:
                return Xe;
        }
    }), Su = F2(function(n, r) {
        switch(n.$){
            case 0:
                return f(d(r, {
                    av: n.a
                }), ye);
            case 1:
                return f(d(r, {
                    aj: n.a
                }), ye);
            case 2:
                return f(d(r, {
                    ax: n.a
                }), ye);
            case 3:
                return f(d(r, {
                    x: yr(n.a),
                    R: A2($e, function(n) {
                        return !!n.cx;
                    }, r.R)
                }), ye);
            case 4:
                return f(d(r, {
                    u: yr(n.a),
                    R: A2($e, function(n) {
                        return 1 !== n.cx;
                    }, r.R)
                }), ye);
            case 5:
                return f(d(r, {
                    O: n.a
                }), ye);
            default:
                return f(d(r, {
                    af: n.a
                }), ye);
        }
    }), Ju = C, Uu = F2(function(n, r) {
        switch(n.$){
            case 0:
                return d(r, {
                    H: yr(n.a)
                });
            case 1:
                return d(r, {
                    J: yr(n.a)
                });
            case 2:
                return d(r, {
                    P: yr(n.a)
                });
            default:
                return d(r, {
                    bc: v(r.bc, n.a)
                });
        }
    }), Fu = Q, Bu = F2(function(n, r) {
        return A2(En, n, Fu(r));
    }), Du = Bu("className"), Hu = {
        H: wr,
        bc: b,
        J: wr,
        P: wr
    }, Iu = F2(function(n, r) {
        return r.$ ? wr : yr(n(r.a));
    }), qu = function(n) {
        switch(n){
            case 0:
                return wr;
            case 1:
                return yr("sm");
            case 2:
                return yr("md");
            case 3:
                return yr("lg");
            default:
                return yr("xl");
        }
    }, Gu = function(n) {
        var r = n.da;
        return Du("text" + (A2(le, "-", A2(Iu, function(n) {
            return "-" + n + "-";
        }, qu(n.aa))) + function(n) {
            switch(n){
                case 1:
                    return "center";
                case 0:
                    return "left";
                default:
                    return "right";
            }
        }(r)));
    }, zu = F2(function(n, r) {
        return Du(n + "-" + function() {
            switch(r){
                case 0:
                    return "primary";
                case 1:
                    return "secondary";
                case 2:
                    return "success";
                case 3:
                    return "info";
                case 4:
                    return "warning";
                case 5:
                    return "danger";
                case 6:
                    return "light";
                default:
                    return "dark";
            }
        }());
    }), Yu = function(n) {
        return 1 === n.$ ? Du("text-white") : A2(zu, "text", n.a);
    }, Zu = jn("div"), Wu = F2(function(n, r) {
        var t;
        return t = A2(Zu, function(n) {
            var r, t, e, u = A3(Er, Uu, Hu, n);
            return v($([
                Du("card-body")
            ]), v((e = u.H).$ ? b : $([
                Gu(e.a)
            ]), v((t = u.J).$ ? b : $([
                A2(zu, "bg", t.a)
            ]), v((r = u.P).$ ? b : $([
                Yu(r.a)
            ]), u.bc))));
        }(n), A2(Rt, function(n) {
            return n;
        }, r)), {
            $: 0,
            a: t
        };
    }), Ku = Wu, Qu = F2(function(n, r) {
        return d(r, {
            bf: n
        });
    }), Vu = F3(function(n, r, t) {
        return {
            bc: r,
            bh: b,
            bi: b,
            dc: n,
            dZ: t
        };
    })(Zu), Xu = {
        $: 1,
        a: {
            $: 1,
            a: 6
        }
    }, na = F2(function(n, r) {
        return d(r, {
            bi: v(n, r.bi)
        });
    }), ra = jn("span"), ta = jn("p"), ea = F2(function(n, r) {
        return A2(ta, v($([
            Du("card-text")
        ]), n), r);
    }), ua = An, aa = F2(function(n, r) {
        return {
            bc: n,
            eg: r
        };
    }), ia = F2(function(n, r) {
        switch(n.$){
            case 0:
                return d(r, {
                    H: yr(n.a)
                });
            case 1:
                return d(r, {
                    J: yr(n.a)
                });
            case 2:
                return d(r, {
                    P: yr(n.a)
                });
            default:
                return d(r, {
                    bc: v(r.bc, n.a)
                });
        }
    }), oa = {
        H: wr,
        bc: b,
        J: wr,
        P: wr
    }, ca = N, fa = F2(function(n, r) {
        return A2(le, {
            an: wr,
            n: 0
        }, A2(be, n, r));
    }), sa = Ln, da = F2(function(n, r) {
        return v($([
            A2(sa, "position", "relative"),
            A2(sa, "height", r),
            A2(sa, "overflow", "hidden")
        ]), n ? $([
            A2(sa, "-webkit-transition-timing-function", "ease"),
            A2(sa, "-o-transition-timing-function", "ease"),
            A2(sa, "transition-timing-function", "ease"),
            A2(sa, "-webkit-transition-duration", "0.35s"),
            A2(sa, "-o-transition-duration", "0.35s"),
            A2(sa, "transition-duration", "0.35s"),
            A2(sa, "-webkit-transition-property", "height"),
            A2(sa, "-o-transition-property", "height"),
            A2(sa, "transition-property", "height")
        ]) : b);
    }), va = F3(function(n, r, t) {
        var e = t.ex, u = da(r.ae), a = A2(fa, e, n), i = A2(le, "0", A2(Iu, function(n) {
            return ca(n) + "px";
        }, a.an));
        switch(a.n){
            case 0:
            case 1:
                return u("0px");
            case 2:
                return u(i);
            default:
                return u(a.an.$ ? "100%" : i);
        }
    }), ba = Bu("id"), la = function(n) {
        return A2(Rt, function(n) {
            return n.a;
        }, n);
    }, ha = F3(function(n, r, t) {
        var e = t.d8;
        return A2(Zu, v($([
            ba(t.ex)
        ]), A3(va, n, r, t)), $([
            A2(Zu, b, la(e))
        ]));
    }), $a = jn("button"), ga = F2(function(n, r) {
        var t = f(n, r);
        if (t.a) switch(t.b){
            case 0:
                return 1;
            case 1:
                return 3;
            case 3:
                return 2;
            default:
                return 0;
        }
        else switch(t.b){
            case 0:
            default:
                return 3;
            case 3:
                return 0;
        }
    }), pa = F4(function(n, r, t, e) {
        var u = n, i = e.ex, o = A3(Ee, i, A2(le, {
            an: wr,
            n: 0
        }, A2(be, i, u)), u);
        return A2(ct, function(n) {
            var t;
            return dt({
                M: r.cY((t = n, A2(Qe, F2(function(n, e) {
                    return a(n, i) ? {
                        an: yr(t),
                        n: A2(ga, r.ae, e.n)
                    } : 3 === e.n && r.ae && r.aS ? d(e, {
                        n: 2
                    }) : 3 === e.n && !r.ae && r.aS ? d(e, {
                        n: 0
                    }) : e;
                }), o))),
                cO: !0,
                cT: !0
            });
        }, t);
    }), ma = _n, ya = F2(function(n, r) {
        return A2(ma, n, {
            $: 3,
            a: r
        });
    }), wa = F2(function(n, r) {
        return A3(Ot, Bt, r, n);
    }), xa = function(n) {
        return wa($([
            "childNodes",
            jr(n)
        ]));
    }, Aa = function(n) {
        return A2(Bt, "nextSibling", n);
    }, ja = A2(Bt, "offsetHeight", Xt), ka = A2(Bt, "currentTarget", (Nu = Aa(A2(xa, 0, ja)), A2(Bt, "parentElement", Nu))), _a = F3(function(n, r, t) {
        var e = t.et.dZ, u = e.bc, a = e.eg;
        return A2($a, v($([
            Du("btn btn-link"),
            A2(ya, "click", A4(pa, n, r, ka, t))
        ]), u), a);
    }), La = F3(function(n, r, t) {
        var e = t.et;
        return A2(e.dc, v(e.bc, $([
            Du("card-header")
        ])), v(e.bi, v($([
            A3(_a, n, r, t)
        ]), e.bh)));
    }), Ea = F3(function(n, r, t) {
        var e, u, a, i;
        return A2(Zu, v((i = A3(Er, ia, oa, t.bM), v($([
            Du("card")
        ]), v((a = i.J).$ ? b : $(a.a.$ ? [
            A2(zu, "border", a.a.a)
        ] : [
            A2(zu, "bg", a.a.a)
        ]), v((u = i.P).$ ? b : $([
            Yu(u.a)
        ]), v((e = i.H).$ ? b : $([
            Gu(e.a)
        ]), i.bc))))), $([
            Du("card")
        ])), $([
            A3(La, n, r, t),
            A3(ha, n, r, t)
        ]));
    }), Na = F2(function(n, r) {
        var t = r;
        return A2(Zu, b, A2(Rt, A2(Ea, n, t), t.bf));
    }), Ta = function(n) {
        return A2(zr, 2.718281828459045, n + 1) / 10;
    }, Oa = jn("li"), Ra = F2(function(n, r) {
        return {
            eg: r,
            $7: Oa,
            bM: n
        };
    }), Ca = jn("mark"), Pa = function(n) {
        return A2(Nn, "rowspan", jr(n));
    }, Ma = jn("table"), Sa = jn("td"), Ja = jn("tr"), Ua = F2(function(n, r) {
        switch(n.$){
            case 0:
                return d(r, {
                    x: yr(n.a)
                });
            case 3:
                return d(r, {
                    a2: !0
                });
            case 2:
                return d(r, {
                    bl: !0
                });
            case 1:
                return d(r, {
                    a3: !0
                });
            default:
                return d(r, {
                    bc: v(r.bc, n.a)
                });
        }
    }), Fa = {
        a2: !1,
        a3: !1,
        bc: b,
        bl: !1,
        x: wr
    }, Ba = function(n) {
        return n.b;
    }, Da = function(n) {
        return Du(A2(kr, " ", A2(Rt, tt, A2($e, Ba, n))));
    }, Ha = Q, Ia = F2(function(n, r) {
        return A2(En, n, Ha(r));
    })("disabled"), qa = function(n) {
        var r, t = n.eg;
        return A2(n.$7, (r = A3(Er, Ua, Fa, n.bM), v($([
            Da($([
                f("list-group-item", !0),
                f("disabled", r.bl),
                f("active", r.a3),
                f("list-group-item-action", r.a2)
            ]))
        ]), v($([
            Ia(r.bl)
        ]), v(A2(le, b, A2(Iu, function(n) {
            return $([
                A2(zu, "list-group-item", n)
            ]);
        }, r.x)), r.bc)))), t);
    }, Ga = jn("ul"), za = F5(function(n, r, t, e, u) {
        var a, i, o, c, f;
        return A2(Zu, b, $([
            A2(Ma, $([
                Du("table")
            ]), $([
                A2(Ja, b, $([
                    A2(Sa, $([
                        Du("border-0 p-0 text-center align-middle display-4"),
                        Pa(2)
                    ]), $([
                        ua("(")
                    ])),
                    A2(Sa, $([
                        Du("border-0 p-0 text-center lead")
                    ]), $([
                        ua(ca(n.d7))
                    ])),
                    A2(Sa, $([
                        Du("border-0 p-0 text-center align-middle display-4"),
                        Pa(2)
                    ]), $([
                        ua("x")
                    ])),
                    A2(Sa, $([
                        Du("border-0 p-0 text-center lead")
                    ]), $([
                        ua(ca(r.eh))
                    ])),
                    A2(Sa, $([
                        Du("border-0 p-0 text-center align-middle display-4"),
                        Pa(2)
                    ]), $([
                        ua(")")
                    ])),
                    A2(Sa, $([
                        Du("border-0 p-0 text-center align-middle display-4"),
                        Pa(2)
                    ]), $([
                        ua("+")
                    ])),
                    A2(Sa, $([
                        Du("border-0 p-0 text-center align-middle display-4"),
                        Pa(2)
                    ]), $([
                        ua("(")
                    ])),
                    A2(Sa, $([
                        Du("border-0 p-0 text-center lead")
                    ]), $([
                        ua(ca(n.d7))
                    ])),
                    A2(Sa, $([
                        Du("border-0 p-0 text-center align-middle display-4"),
                        Pa(2)
                    ]), $([
                        ua("x")
                    ])),
                    A2(Sa, $([
                        Du("border-0 p-0 text-center lead")
                    ]), $([
                        ua((i = Ta(t), c = ca(100 * i), f = (o = ie(A2(mt, ".", c))).$ ? $t(c) : o.a + 3, A3(gt, 0, f, c) + "%"))
                    ])),
                    A2(Sa, $([
                        Du("border-0 p-0 text-center align-middle display-4"),
                        Pa(2)
                    ]), $([
                        ua(")")
                    ]))
                ])),
                A2(Ja, b, $([
                    A2(Sa, $([
                        Du("border-0 p-0 text-center text-muted")
                    ]), $([
                        ua("(base salary)")
                    ])),
                    A2(Sa, $([
                        Du("border-0 p-0 text-center text-muted")
                    ]), $([
                        ua("(compressed cost of living)")
                    ])),
                    A2(Sa, $([
                        Du("border-0 p-0 text-center text-muted")
                    ]), $([
                        ua("(base salary)")
                    ])),
                    A2(Sa, $([
                        Du("border-0 p-0 text-center text-muted")
                    ]), $([
                        ua("(commitment bonus)")
                    ]))
                ]))
            ])),
            (a = $([
                A2(Ra, b, $([
                    A2(ra, $([
                        Du("font-weight-bold")
                    ]), $([
                        ua("Base Salary: ")
                    ])),
                    ua("US median for "),
                    A2(Ca, b, $([
                        ua(n.dv)
                    ])),
                    ua(" on Salary.com, divided by 12 (months) and converted to EUR using a 10-year USD -> EUR average. "),
                    ua("This value was fetched from Salary.com on "),
                    A2(Ca, b, $([
                        ua(e)
                    ])),
                    ua(".")
                ])),
                A2(Ra, b, $([
                    A2(ra, $([
                        Du("font-weight-bold")
                    ]), $([
                        ua("Compressed Cost of Living: ")
                    ])),
                    ua("Numbeo Cost of Living in "),
                    A2(Ca, b, $([
                        ua(r.dv)
                    ])),
                    ua(" compared to United States, compressed against our Affordability Ratio of 0.49. "),
                    ua("This value was fetched from Numbeo on "),
                    A2(Ca, b, $([
                        ua(u)
                    ])),
                    ua(".")
                ])),
                A2(Ra, b, $([
                    A2(ra, $([
                        Du("font-weight-bold")
                    ]), $([
                        ua("Commitment Bonus: ")
                    ])),
                    ua("Natural logarithm of "),
                    A2(Ca, b, $([
                        ua(jr(t))
                    ])),
                    ua(" years of your tenure, divided by 10.")
                ])),
                A2(Ra, b, $([
                    A2(ra, $([
                        Du("font-weight-bold")
                    ]), $([
                        ua("Affordability Ratio: ")
                    ])),
                    ua("The value is set somewhat arbitrarily, to match our salaries before the introduction of Salary System v2.0. The value in v1.0 was set to reflect the average cost of living in 4 major European tech hubs. We adjust the Affordability Ratio every January, based on the previous year's performance.")
                ]))
            ]), A2(Ga, $([
                Du("list-group")
            ]), A2(Rt, qa, a)))
        ]));
    }), Ya = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Za = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Wa = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Ka = Bu("type"), Qa = F2(function(n, r) {
        return A2($a, v($([
            Ka("button"),
            Du("dropdown-item")
        ]), n), r);
    }), Va = F2(function(n, r) {
        return v($([
            Da($([
                f("btn-group", !0),
                f("show", 2 !== n),
                f("dropup", r.aL)
            ]))
        ]), v(A2(le, b, A2(Iu, function(n) {
            return $([
                Du("drop" + (n ? "right" : "left"))
            ]);
        }, r.aH)), r.bc));
    }), Xa = F2(function(n, r) {
        var t = n.cc, e = n.aP, u = function(n) {
            return ca(n) + "px";
        }, a = F3(function(n, r, t) {
            return "translate3d(" + u(n) + "," + u(r) + "," + u(t) + ")";
        }), i = $([
            A2(sa, "top", "0"),
            A2(sa, "left", "0")
        ]), o = f(r.aL, r.aH);
        n: for(;;){
            if (o.b.$) {
                if (o.a) break n;
                return v(i, $([
                    A2(sa, "transform", A3(a, -t.aA, t.an, 0))
                ]));
            }
            if (1 === o.b.a) {
                if (o.a) break n;
                return i;
            }
            if (o.a) break n;
            return v(i, $([
                A2(sa, "transform", A3(a, -t.aA - e.aA, 0, 0))
            ]));
        }
        return v(i, $([
            A2(sa, "transform", A3(a, -t.aA, -e.an, 0))
        ]));
    }), ni = F3(function(n, r, t) {
        var e = $(2 === n.A ? [
            A2(sa, "height", "0"),
            A2(sa, "overflow", "hidden"),
            A2(sa, "position", "relative")
        ] : [
            A2(sa, "position", "relative")
        ]);
        return A2(Zu, e, $([
            A2(Zu, v($([
                Da($([
                    f("dropdown-menu", !0),
                    f("dropdown-menu-right", r.bu),
                    f("show", !0)
                ]))
            ]), v(A2(Xa, n, r), r.bA)), A2(Rt, function(n) {
                return n;
            }, t))
        ]));
    }), ri = F2(function(n, r) {
        switch(n.$){
            case 1:
                return d(r, {
                    bu: !0
                });
            case 0:
                return d(r, {
                    aL: !0
                });
            case 4:
                return d(r, {
                    bc: n.a
                });
            case 2:
                return d(r, {
                    aH: yr(n.a)
                });
            default:
                return d(r, {
                    bA: n.a
                });
        }
    }), ti = {
        bc: b,
        aH: wr,
        bu: !1,
        aL: !1,
        bA: b
    }, ei = F2(function(n, r) {
        var t = n.A, e = r.c_, u = r.cZ, a = r.cF, i = A3(Er, ri, ti, r.bM), o = u;
        return A2(Zu, A2(Va, t, i), $([
            A2(o, e, n),
            A3(ni, n, i, a)
        ]));
    }), ui = jn("h6"), ai = function(n) {
        return 1 > n ? "Just started" : 1 === n ? jr(n) + " year" : jr(n) + " years";
    }, ii = F2(function(n, r) {
        return A2(ma, n, {
            $: 0,
            a: r
        });
    }), oi = function(n) {
        return A2(ii, "click", dt(n));
    }, ci = {
        $: 1,
        a: {
            $: 1,
            a: 0
        }
    }, fi = F2(function(n, r) {
        return r.$ ? wr : n(r.a);
    }), si = F2(function(n, r) {
        switch(n.$){
            case 0:
                return d(r, {
                    aa: yr(n.a)
                });
            case 1:
                return d(r, {
                    J: yr(n.a)
                });
            case 2:
                return d(r, {
                    be: !0
                });
            case 3:
                return d(r, {
                    bl: n.a
                });
            default:
                return d(r, {
                    bc: v(r.bc, n.a)
                });
        }
    }), di = {
        bc: b,
        be: !1,
        J: wr,
        bl: !1,
        aa: wr
    }, vi = function(n) {
        switch(n){
            case 0:
                return "primary";
            case 1:
                return "secondary";
            case 2:
                return "success";
            case 3:
                return "info";
            case 4:
                return "warning";
            case 5:
                return "danger";
            case 6:
                return "dark";
            case 7:
                return "light";
            default:
                return "link";
        }
    }, bi = function(n) {
        switch(n){
            case 0:
            case 1:
                return 2;
            default:
                return 0;
        }
    }, li = B, hi = A2(Bt, "offsetWidth", Xt), $i = A2(Bt, "offsetLeft", Xt), gi = function(n) {
        return {
            $: 11,
            g: n
        };
    }, pi = F2(function(n, r) {
        var t;
        return gi($([
            A2(Bt, "offsetParent", (t = n, {
                $: 5,
                c: t
            })),
            A2(Bt, "offsetParent", r)
        ]));
    }), mi = A2(Bt, "offsetTop", Xt), yi = A2(Bt, "scrollLeft", Xt), wi = A2(Bt, "scrollTop", Xt), xi = F2(function(n, r) {
        return A2(ct, function(n) {
            var r = n.a, t = n.b;
            return A2(pi, f(r, t), A2(xi, r, t));
        }, A5(re, F4(function(t, e, u, a) {
            return f(n + u - t, r + a - e);
        }), yi, wi, $i, mi));
    }), Ai = A4(li, F3(function(n, r, t) {
        return {
            an: t,
            Y: n.a,
            ab: n.b,
            aA: r
        };
    }), A2(xi, 0, 0), hi, ja), ji = F2(function(n, r) {
        return f(n, r);
    }), ki = A2(wa, $([
        "className"
    ]), Kt), _i = A2(ct, function(n) {
        return dt(!!A2(ht, "dropdown-toggle", n));
    }, ki), Li = F2(function(n, r) {
        return gi($([
            A2(ct, function(t) {
                return t ? A2(wa, n, r) : Yt("");
            }, A2(wa, n, _i)),
            A2(ct, function() {
                return A2(Li, v(n, $([
                    "parentElement"
                ])), r);
            }, A2(wa, v(n, $([
                "parentElement"
            ])), ki)),
            Yt("No toggler found")
        ]));
    }), Ei = A3(st, ji, A2(Li, $([
        "target"
    ]), Ai), A2(Li, $([
        "target"
    ]), Aa(A2(xa, 0, Ai)))), Ni = F2(function(n, r) {
        var t = r.A;
        return A2(ct, function(r) {
            var e = r.a;
            return dt(n({
                aP: r.b,
                A: bi(t),
                cc: e
            }));
        }, Ei);
    }), Ti = F4(function(n, r, t, e) {
        var u, a, i;
        return A2($a, v((i = A3(Er, si, di, n), v($([
            Da($([
                f("btn", !0),
                f("btn-block", i.be),
                f("disabled", i.bl)
            ])),
            Ia(i.bl)
        ]), v((a = A2(fi, qu, i.aa)).$ ? b : $([
            Du("btn-" + a.a)
        ]), v((u = i.J).$ ? b : $(u.a.$ ? [
            Du("btn-outline-" + vi(u.a.a))
        ] : [
            Du("btn-" + vi(u.a.a))
        ]), i.bc)))), $([
            Du("dropdown-toggle"),
            Ka("button"),
            A2(ii, "click", A2(Ni, t, e))
        ])), r);
    }), Oi = F2(function(n, r) {
        return A2(Ti, n, r);
    }), Ri = y, Ci = F3(function(n, r, t) {
        return Ri(n.d7 * r.eh + n.d7 * Ta(t));
    }), Pi = F3(function(n, r, t) {
        var e = f(n, r);
        if (1 === e.a.$) return ua(1 === e.b.$ ? "Please select a role and a country." : "Please select a role.");
        if (1 === e.b.$) return ua("Please select a country.");
        var u = e.a.a, a = e.b.a;
        return A2(ra, b, $([
            ua("My monthly gross salary is "),
            A2(ra, $([
                Du("font-weight-bold"),
                ba("total-salary")
            ]), $([
                ua(jr(A3(Ci, u, a, t)) + " €")
            ])),
            ua(".")
        ]));
    }), Mi = function(n) {
        var r, t = function(n) {
            return A2(Qa, $([
                oi(Wa(n))
            ]), $([
                ua(ai(n))
            ]));
        }, e = function(n) {
            return A2(Qa, $([
                oi(Za(n))
            ]), $([
                ua(n.dv)
            ]));
        }, u = function(n) {
            return A2(Qa, $([
                oi(Ya(n))
            ]), $([
                ua(n.dv)
            ]));
        };
        return $([
            A2(ta, $([
                Du("lead")
            ]), $([
                ua("I'm a "),
                A2(ei, n.av, {
                    cF: qt(A2(Rt, function(n) {
                        var r, t = n.e$;
                        return A2(cr, (r = $([
                            ua(n.dv + " Career")
                        ]), A2(ui, $([
                            Du("dropdown-header")
                        ]), r)), A2(Rt, e, t));
                    }, n.ec)),
                    bM: b,
                    cZ: A2(Oi, $([
                        ci
                    ]), $([
                        ua(A2(le, "select a role", A2(Iu, function(n) {
                            return n.dv;
                        }, n.x)))
                    ])),
                    c_: Ye
                }),
                ua(" living in "),
                A2(ei, n.aj, {
                    cF: A2(Rt, u, n.ej),
                    bM: b,
                    cZ: A2(Oi, $([
                        ci
                    ]), $([
                        ua(A2(le, "select a country", A2(Iu, function(n) {
                            return n.dv;
                        }, n.u)))
                    ])),
                    c_: ze
                }),
                ua(" with a tenure at Niteo of "),
                A2(ei, n.ax, {
                    cF: $([
                        t(0),
                        t(1),
                        t(2),
                        t(3),
                        t(4),
                        t(5),
                        t(6),
                        t(7),
                        t(8),
                        t(9),
                        t(10),
                        t(11),
                        t(12),
                        t(15),
                        t(20)
                    ]),
                    bM: b,
                    cZ: A2(Oi, $([
                        ci
                    ]), $([
                        ua(jr(n.O))
                    ])),
                    c_: Ze
                }),
                (r = n.O, ua(r && 1 === r ? " year." : " years."))
            ])),
            A2(ta, $([
                Du("lead")
            ]), $([
                A3(Pi, n.x, n.u, n.O)
            ]))
        ]);
    }, Si = F2(function(n, r) {
        return d(r, {
            bc: n
        });
    }), Ji = F2(function(n, r) {
        return d(r, {
            eg: n
        });
    }), Ui = {
        bc: b,
        eg: b,
        U: wr,
        x: 1,
        n: 0,
        ae: !1
    }, Fi = F2(function(n, r) {
        return d(r, {
            x: n
        });
    }), Bi = F2(function(n, r) {
        return A2(Nn, function(n) {
            return /^(on|formAction$)/i.test(n) ? "data-" + n : n;
        }(n), function(n) {
            return /^\s*(javascript:|data:text\/html)/i.test(n) ? "" : n;
        }(r));
    }), Di = F2(function(n, r) {
        var t = r.U;
        return t.$ ? b : $([
            A2(F2(function(n, r) {
                return oi(r(n));
            }), r.ae ? 1 : 3, t.a)
        ]);
    }), Hi = F2(function(n, r) {
        return r.b ? A2(cr, r.a, A2(cr, n, r.b)) : $([
            n
        ]);
    }), Ii = function(n) {
        return !n.U.$;
    }, qi = F3(function(n, r, t) {
        return Ii(r) ? A2(Hi, A2($a, v($([
            Ka("button"),
            Du("close"),
            A2(Bi, "aria-label", "close")
        ]), A2(Di, n, r)), $([
            A2(ra, $([
                A2(Bi, "aria-hidden", "true")
            ]), $([
                ua("\xd7")
            ]))
        ])), t) : t;
    }), Gi = F2(function(n, r) {
        var t = 3 === n ? $([
            A2(sa, "display", "none")
        ]) : b, e = function() {
            if (r.ae) {
                var n = r.U;
                return n.$ ? b : $([
                    A2(ii, "transitionend", dt((0, n.a)(3)))
                ]);
            }
            return b;
        }(), u = $([
            A2(Bi, "role", "alert"),
            Da($([
                f("alert", !0),
                f("alert-dismissible", Ii(r)),
                f("fade", r.ae),
                f("show", !n)
            ])),
            A2(zu, "alert", r.x)
        ]);
        return qt($([
            r.bc,
            u,
            t,
            e
        ]));
    }), zi = F2(function(n, r) {
        var t = r;
        return A2(Zu, A2(Gi, n, t), A3(qi, n, t, t.eg));
    }), Yi = F3(function(n, r, t) {
        return A2(zi, 0, A2(Ji, t, A2(Si, r, A2(Fi, n, Ui))));
    })(4), Zi = function(n) {
        return $([
            n
        ]);
    }, Wi = function(n) {
        return d(n, {
            ae: !0
        });
    };
    Tu = {
        Main: {
            init: Ft({
                eA: function(n) {
                    return f(function() {
                        var r = A2(ee, te, n.ct);
                        if (1 === r.$) return {
                            af: fe,
                            ec: b,
                            ed: "1970-01-01",
                            ej: b,
                            ek: "1970-01-01",
                            u: wr,
                            aj: de,
                            bm: yr(Br(r.a)),
                            x: wr,
                            av: de,
                            O: 0,
                            ax: de,
                            R: b
                        };
                        var t, e = r.a, u = qt(A2(Rt, function(n) {
                            return n.e$;
                        }, e.ec)), a = A4(me, Dt, He("role"), He("country"), A2(he, "years", function(n) {
                            return n.b && !n.b.b ? xt(n.a) : wr;
                        })), i = A2(De, Ie, a), o = A2(Lt, "http://", t = n.cG) ? A2(_t, 0, A2(pt, 7, t)) : A2(Lt, "https://", t) ? A2(_t, 1, A2(pt, 8, t)) : wr, c = o.$ ? {
                            u: wr,
                            x: wr,
                            cp: wr
                        } : A2(le, {
                            u: wr,
                            x: wr,
                            cp: wr
                        }, A2(Ue, i, d(o.a, {
                            eV: "/"
                        }))), f = function() {
                            var n = c.x;
                            if (n.$) return pr(ie(u));
                            var r = n.a;
                            return A2(pe, yr, A2(ae, A2(Ht, "Invalid role provided via URL: " + r + ". Please choose one from the dropdown below.", 0), A2(ge, r, u)));
                        }(), s = function() {
                            var n = c.u;
                            if (n.$) return pr(ie(e.ej));
                            var r = n.a;
                            return A2(pe, yr, A2(ae, A2(Ht, "Invalid country provided via URL: " + r + ". Please choose one from the dropdown below.", 1), A2(ge, r, e.ej)));
                        }(), v = qe($([
                            f.$ ? yr(f.a) : wr,
                            s.$ ? yr(s.a) : wr
                        ]));
                        return {
                            af: fe,
                            ec: e.ec,
                            ed: e.ed,
                            ej: e.ej,
                            ek: e.ek,
                            u: A2(ue, function() {
                                return wr;
                            }, s),
                            aj: de,
                            bm: wr,
                            x: A2(ue, function() {
                                return wr;
                            }, f),
                            av: de,
                            O: A2(le, 2, c.cp),
                            ax: de,
                            R: v
                        };
                    }(), ye);
                },
                e2: function(n) {
                    return We($([
                        A2(Mu, n.av, Ye),
                        A2(Mu, n.aj, ze),
                        A2(Mu, n.ax, Ze),
                        A2(lu, n.af, Ge)
                    ]));
                },
                e7: Su,
                e8: function(n) {
                    var r, t, e, u, i = n.bm;
                    return i.$ ? A2(Zu, b, $([
                        (u = n.R, A2(Zu, b, A2(Rt, Yi(b), A2(Rt, Zi, A2(Rt, ua, A2(Rt, function(n) {
                            return n.du;
                        }, u)))))),
                        A2(Na, n.af, A2(Qu, $([
                            (e = {
                                d8: (t = f(n.x, n.u), 1 === t.a.$ || 1 === t.b.$ ? b : $([
                                    A2(Ku, b, $([
                                        A2(ea, b, $([
                                            A5(za, t.a.a, t.b.a, n.O, n.ed, n.ek)
                                        ]))
                                    ]))
                                ])),
                                et: A2(na, Mi(n), A2(Vu, b, A2(aa, $([
                                    Du("p-0")
                                ]), $([
                                    A2(ra, b, $([
                                        a(n.x, wr) || a(n.u, wr) ? ua("") : ua("Okay, let's break that down ...")
                                    ]))
                                ])))),
                                ex: "card1",
                                bM: $([
                                    Xu
                                ])
                            }, {
                                d8: e.d8,
                                et: e.et,
                                ex: e.ex,
                                bM: e.bM
                            })
                        ]), Wi((r = Ge, {
                            bf: b,
                            aS: !1,
                            cY: r,
                            ae: !1
                        }))))
                    ])) : ua("App initialization failed: " + i.a);
                }
            })(A2(ct, function(n) {
                return A2(ct, function(r) {
                    return dt({
                        ct: r,
                        cG: n
                    });
                }, A2(Bt, "config", Ju));
            }, A2(Bt, "location", Kt)))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? u(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, Tu) : n.Elm = Tu;
}($c4926bcb88dfb64a$exports);


var $53834bdc4e950c27$exports = {};
$53834bdc4e950c27$exports = {
    "eur_to_usd_10_year_avg": 1.188703,
    "careers_updated": "2023-12-31",
    "careers": [
        {
            "name": "Design",
            "roles": [
                {
                    "name": "Junior Designer",
                    "baseSalary": 4721,
                    "salary_com_key": "web-designer-i"
                },
                {
                    "name": "Designer",
                    "baseSalary": 5626,
                    "salary_com_key": "web-designer-ii"
                },
                {
                    "name": "Senior Designer",
                    "baseSalary": 6950,
                    "salary_com_key": "web-designer-iii"
                },
                {
                    "name": "Lead Designer",
                    "baseSalary": 8768,
                    "salary_com_key": "web-designer-iv"
                },
                {
                    "name": "Principal Designer",
                    "baseSalary": 10070,
                    "salary_com_key": "art-director"
                }
            ]
        },
        {
            "name": "Marketing",
            "roles": [
                {
                    "name": "Junior Digital Marketer",
                    "baseSalary": 4308,
                    "salary_com_key": "digital-marketing-analyst-i"
                },
                {
                    "name": "Digital Marketer",
                    "baseSalary": 5249,
                    "salary_com_key": "digital-marketing-analyst-ii"
                },
                {
                    "name": "Senior Digital Marketer",
                    "baseSalary": 6669,
                    "salary_com_key": "digital-marketing-analyst-iii"
                },
                {
                    "name": "Lead Digital Marketer",
                    "baseSalary": 8634,
                    "salary_com_key": "digital-marketing-manager"
                },
                {
                    "name": "Principal Digital Marketer",
                    "baseSalary": 13119,
                    "salary_com_key": "digital-marketing-director"
                }
            ]
        },
        {
            "name": "Operations",
            "roles": [
                {
                    "name": "Tech Support I",
                    "baseSalary": 4730,
                    "salary_com_key": "technical-support-analyst-i"
                },
                {
                    "name": "Tech Support II",
                    "baseSalary": 5963,
                    "salary_com_key": "technical-support-analyst-ii"
                },
                {
                    "name": "Support Manager",
                    "baseSalary": 5654,
                    "salary_com_key": "it-project-manager-i"
                },
                {
                    "name": "Project Manager",
                    "baseSalary": 7133,
                    "salary_com_key": "it-project-manager-ii"
                },
                {
                    "name": "Operations Manager",
                    "baseSalary": 8629,
                    "salary_com_key": "it-project-manager-iii"
                }
            ]
        },
        {
            "name": "Technical",
            "roles": [
                {
                    "name": "Junior Software Engineer",
                    "baseSalary": 5442,
                    "salary_com_key": "software-engineer-i"
                },
                {
                    "name": "Software Engineer",
                    "baseSalary": 6844,
                    "salary_com_key": "software-engineer-ii"
                },
                {
                    "name": "Senior Software Engineer",
                    "baseSalary": 8566,
                    "salary_com_key": "software-engineer-iii"
                },
                {
                    "name": "Lead Software Engineer",
                    "baseSalary": 10005,
                    "salary_com_key": "software-engineer-iv"
                },
                {
                    "name": "Principal Software Engineer",
                    "baseSalary": 11814,
                    "salary_com_key": "software-engineer-v"
                },
                {
                    "name": "Information Technology Director",
                    "baseSalary": 14156,
                    "salary_com_key": "information-technology-director"
                }
            ]
        }
    ],
    "affordability": 0.49,
    "countries_updated": "2023-12-30",
    "countries": [
        {
            "name": "Albania",
            "cost_of_living": 0.44,
            "compressed_cost_of_living": 0.47
        },
        {
            "name": "Algeria",
            "cost_of_living": 0.29,
            "compressed_cost_of_living": 0.42
        },
        {
            "name": "Argentina",
            "cost_of_living": 0.29,
            "compressed_cost_of_living": 0.42
        },
        {
            "name": "Armenia",
            "cost_of_living": 0.49,
            "compressed_cost_of_living": 0.49
        },
        {
            "name": "Australia",
            "cost_of_living": 0.95,
            "compressed_cost_of_living": 0.64
        },
        {
            "name": "Austria",
            "cost_of_living": 0.76,
            "compressed_cost_of_living": 0.58
        },
        {
            "name": "Bangladesh",
            "cost_of_living": 0.23,
            "compressed_cost_of_living": 0.4
        },
        {
            "name": "Belarus",
            "cost_of_living": 0.29,
            "compressed_cost_of_living": 0.42
        },
        {
            "name": "Belgium",
            "cost_of_living": 0.72,
            "compressed_cost_of_living": 0.57
        },
        {
            "name": "Bolivia",
            "cost_of_living": 0.3,
            "compressed_cost_of_living": 0.43
        },
        {
            "name": "Bosnia And Herzegovina",
            "cost_of_living": 0.35,
            "compressed_cost_of_living": 0.44
        },
        {
            "name": "Brazil",
            "cost_of_living": 0.38,
            "compressed_cost_of_living": 0.45
        },
        {
            "name": "Bulgaria",
            "cost_of_living": 0.41,
            "compressed_cost_of_living": 0.46
        },
        {
            "name": "Cambodia",
            "cost_of_living": 0.41,
            "compressed_cost_of_living": 0.46
        },
        {
            "name": "Canada",
            "cost_of_living": 0.88,
            "compressed_cost_of_living": 0.62
        },
        {
            "name": "Chile",
            "cost_of_living": 0.46,
            "compressed_cost_of_living": 0.48
        },
        {
            "name": "Colombia",
            "cost_of_living": 0.33,
            "compressed_cost_of_living": 0.44
        },
        {
            "name": "Costa Rica",
            "cost_of_living": 0.57,
            "compressed_cost_of_living": 0.52
        },
        {
            "name": "Croatia",
            "cost_of_living": 0.5,
            "compressed_cost_of_living": 0.49
        },
        {
            "name": "Cyprus",
            "cost_of_living": 0.72,
            "compressed_cost_of_living": 0.56
        },
        {
            "name": "Czech Republic",
            "cost_of_living": 0.6,
            "compressed_cost_of_living": 0.53
        },
        {
            "name": "Denmark",
            "cost_of_living": 0.87,
            "compressed_cost_of_living": 0.62
        },
        {
            "name": "Dominican Republic",
            "cost_of_living": 0.42,
            "compressed_cost_of_living": 0.47
        },
        {
            "name": "Ecuador",
            "cost_of_living": 0.35,
            "compressed_cost_of_living": 0.44
        },
        {
            "name": "Egypt",
            "cost_of_living": 0.24,
            "compressed_cost_of_living": 0.41
        },
        {
            "name": "El Salvador",
            "cost_of_living": 0.47,
            "compressed_cost_of_living": 0.49
        },
        {
            "name": "Estonia",
            "cost_of_living": 0.58,
            "compressed_cost_of_living": 0.52
        },
        {
            "name": "Ethiopia",
            "cost_of_living": 0.48,
            "compressed_cost_of_living": 0.49
        },
        {
            "name": "Finland",
            "cost_of_living": 0.73,
            "compressed_cost_of_living": 0.57
        },
        {
            "name": "France",
            "cost_of_living": 0.76,
            "compressed_cost_of_living": 0.58
        },
        {
            "name": "Georgia",
            "cost_of_living": 0.44,
            "compressed_cost_of_living": 0.47
        },
        {
            "name": "Germany",
            "cost_of_living": 0.76,
            "compressed_cost_of_living": 0.58
        },
        {
            "name": "Ghana",
            "cost_of_living": 0.31,
            "compressed_cost_of_living": 0.43
        },
        {
            "name": "Greece",
            "cost_of_living": 0.58,
            "compressed_cost_of_living": 0.52
        },
        {
            "name": "Guatemala",
            "cost_of_living": 0.41,
            "compressed_cost_of_living": 0.46
        },
        {
            "name": "Honduras",
            "cost_of_living": 0.4,
            "compressed_cost_of_living": 0.46
        },
        {
            "name": "Hungary",
            "cost_of_living": 0.48,
            "compressed_cost_of_living": 0.49
        },
        {
            "name": "Iceland",
            "cost_of_living": 0.95,
            "compressed_cost_of_living": 0.64
        },
        {
            "name": "India",
            "cost_of_living": 0.24,
            "compressed_cost_of_living": 0.41
        },
        {
            "name": "Indonesia",
            "cost_of_living": 0.31,
            "compressed_cost_of_living": 0.43
        },
        {
            "name": "Ireland",
            "cost_of_living": 0.95,
            "compressed_cost_of_living": 0.64
        },
        {
            "name": "Israel",
            "cost_of_living": 0.82,
            "compressed_cost_of_living": 0.6
        },
        {
            "name": "Italy",
            "cost_of_living": 0.68,
            "compressed_cost_of_living": 0.55
        },
        {
            "name": "Japan",
            "cost_of_living": 0.57,
            "compressed_cost_of_living": 0.52
        },
        {
            "name": "Jordan",
            "cost_of_living": 0.43,
            "compressed_cost_of_living": 0.47
        },
        {
            "name": "Kenya",
            "cost_of_living": 0.27,
            "compressed_cost_of_living": 0.42
        },
        {
            "name": "Kuwait",
            "cost_of_living": 0.56,
            "compressed_cost_of_living": 0.51
        },
        {
            "name": "Latvia",
            "cost_of_living": 0.53,
            "compressed_cost_of_living": 0.5
        },
        {
            "name": "Lebanon",
            "cost_of_living": 0.53,
            "compressed_cost_of_living": 0.5
        },
        {
            "name": "Libya",
            "cost_of_living": 0.22,
            "compressed_cost_of_living": 0.4
        },
        {
            "name": "Lithuania",
            "cost_of_living": 0.55,
            "compressed_cost_of_living": 0.51
        },
        {
            "name": "Luxembourg",
            "cost_of_living": 0.9,
            "compressed_cost_of_living": 0.62
        },
        {
            "name": "Malaysia",
            "cost_of_living": 0.33,
            "compressed_cost_of_living": 0.44
        },
        {
            "name": "Malta",
            "cost_of_living": 0.68,
            "compressed_cost_of_living": 0.55
        },
        {
            "name": "Mexico",
            "cost_of_living": 0.5,
            "compressed_cost_of_living": 0.49
        },
        {
            "name": "Moldova",
            "cost_of_living": 0.38,
            "compressed_cost_of_living": 0.45
        },
        {
            "name": "Montenegro",
            "cost_of_living": 0.49,
            "compressed_cost_of_living": 0.49
        },
        {
            "name": "Morocco",
            "cost_of_living": 0.32,
            "compressed_cost_of_living": 0.43
        },
        {
            "name": "Namibia",
            "cost_of_living": 0.35,
            "compressed_cost_of_living": 0.44
        },
        {
            "name": "Nepal",
            "cost_of_living": 0.26,
            "compressed_cost_of_living": 0.41
        },
        {
            "name": "Netherlands",
            "cost_of_living": 0.83,
            "compressed_cost_of_living": 0.6
        },
        {
            "name": "New Zealand",
            "cost_of_living": 0.83,
            "compressed_cost_of_living": 0.6
        },
        {
            "name": "Nicaragua",
            "cost_of_living": 0.35,
            "compressed_cost_of_living": 0.44
        },
        {
            "name": "Nigeria",
            "cost_of_living": 0.28,
            "compressed_cost_of_living": 0.42
        },
        {
            "name": "North Macedonia",
            "cost_of_living": 0.34,
            "compressed_cost_of_living": 0.44
        },
        {
            "name": "Norway",
            "cost_of_living": 0.92,
            "compressed_cost_of_living": 0.63
        },
        {
            "name": "Oman",
            "cost_of_living": 0.48,
            "compressed_cost_of_living": 0.49
        },
        {
            "name": "Pakistan",
            "cost_of_living": 0.18,
            "compressed_cost_of_living": 0.39
        },
        {
            "name": "Palestine",
            "cost_of_living": 0.44,
            "compressed_cost_of_living": 0.47
        },
        {
            "name": "Panama",
            "cost_of_living": 0.56,
            "compressed_cost_of_living": 0.51
        },
        {
            "name": "Paraguay",
            "cost_of_living": 0.31,
            "compressed_cost_of_living": 0.43
        },
        {
            "name": "Peru",
            "cost_of_living": 0.35,
            "compressed_cost_of_living": 0.44
        },
        {
            "name": "Philippines",
            "cost_of_living": 0.35,
            "compressed_cost_of_living": 0.45
        },
        {
            "name": "Poland",
            "cost_of_living": 0.52,
            "compressed_cost_of_living": 0.5
        },
        {
            "name": "Portugal",
            "cost_of_living": 0.6,
            "compressed_cost_of_living": 0.53
        },
        {
            "name": "Puerto Rico",
            "cost_of_living": 0.75,
            "compressed_cost_of_living": 0.57
        },
        {
            "name": "Qatar",
            "cost_of_living": 0.77,
            "compressed_cost_of_living": 0.58
        },
        {
            "name": "Romania",
            "cost_of_living": 0.42,
            "compressed_cost_of_living": 0.47
        },
        {
            "name": "Russia",
            "cost_of_living": 0.34,
            "compressed_cost_of_living": 0.44
        },
        {
            "name": "Rwanda",
            "cost_of_living": 0.3,
            "compressed_cost_of_living": 0.43
        },
        {
            "name": "Senegal",
            "cost_of_living": 0.55,
            "compressed_cost_of_living": 0.51
        },
        {
            "name": "Serbia",
            "cost_of_living": 0.43,
            "compressed_cost_of_living": 0.47
        },
        {
            "name": "Singapore",
            "cost_of_living": 0.69,
            "compressed_cost_of_living": 0.56
        },
        {
            "name": "Slovakia",
            "cost_of_living": 0.53,
            "compressed_cost_of_living": 0.5
        },
        {
            "name": "Slovenia",
            "cost_of_living": 0.56,
            "compressed_cost_of_living": 0.51
        },
        {
            "name": "South Africa",
            "cost_of_living": 0.39,
            "compressed_cost_of_living": 0.46
        },
        {
            "name": "South Korea",
            "cost_of_living": 0.69,
            "compressed_cost_of_living": 0.56
        },
        {
            "name": "Spain",
            "cost_of_living": 0.61,
            "compressed_cost_of_living": 0.53
        },
        {
            "name": "Sri Lanka",
            "cost_of_living": 0.31,
            "compressed_cost_of_living": 0.43
        },
        {
            "name": "Sweden",
            "cost_of_living": 0.74,
            "compressed_cost_of_living": 0.57
        },
        {
            "name": "Switzerland",
            "cost_of_living": 0.56,
            "compressed_cost_of_living": 0.51
        },
        {
            "name": "Syria",
            "cost_of_living": 0.24,
            "compressed_cost_of_living": 0.41
        },
        {
            "name": "Taiwan",
            "cost_of_living": 0.53,
            "compressed_cost_of_living": 0.5
        },
        {
            "name": "Tanzania",
            "cost_of_living": 0.29,
            "compressed_cost_of_living": 0.42
        },
        {
            "name": "Thailand",
            "cost_of_living": 0.42,
            "compressed_cost_of_living": 0.47
        },
        {
            "name": "Tunisia",
            "cost_of_living": 0.28,
            "compressed_cost_of_living": 0.42
        },
        {
            "name": "Turkey",
            "cost_of_living": 0.38,
            "compressed_cost_of_living": 0.45
        },
        {
            "name": "Ukraine",
            "cost_of_living": 0.31,
            "compressed_cost_of_living": 0.43
        },
        {
            "name": "United Kingdom",
            "cost_of_living": 0.81,
            "compressed_cost_of_living": 0.6
        },
        {
            "name": "United States",
            "cost_of_living": 1,
            "compressed_cost_of_living": 0.66
        },
        {
            "name": "Uruguay",
            "cost_of_living": 0.58,
            "compressed_cost_of_living": 0.52
        },
        {
            "name": "Venezuela",
            "cost_of_living": 0.38,
            "compressed_cost_of_living": 0.45
        },
        {
            "name": "Vietnam",
            "cost_of_living": 0.34,
            "compressed_cost_of_living": 0.44
        }
    ]
};


(0, $c4926bcb88dfb64a$exports.Elm).Main.init({
    flags: {
        location: location.href,
        config: (/*@__PURE__*/$parcel$interopDefault($53834bdc4e950c27$exports))
    },
    node: document.getElementById("app-container")
});



})();
//# sourceMappingURL=salary-calculator.js.map
